/**
 * @param {string} type
 * @param {string} url
 */

export default class GetFormDTO {
  constructor({ type, url } = {}) {
    /**
     * The type of the form (e.g., 'internal').
     * @type {string}
     */
    this.type = type
    /**
     * The URL for the form.
     * @type {string}
     */
    this.url = url
  }
}
